import { render } from "./Header.vue?vue&type=template&id=04376e9f&scoped=true"
import script from "./Header.vue?vue&type=script&lang=js"
export * from "./Header.vue?vue&type=script&lang=js"

import "./Header.vue?vue&type=style&index=0&id=04376e9f&lang=less&scoped=true"

import exportComponent from "/home/jenkins/agent/workspace/build_logistics-fe-ntp-hz_a3ee6c512411489faef2ecfce652dcca/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04376e9f"]])

export default __exports__